import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Page404 from '../exception/routes/404';
import DynApp from '../core/DynApp';

const App = (props) => {
  const { match } = props;
  return (
    <div id="app-inner">
      <Switch>
        <Route path={`${match.url}`} component={DynApp} />
        <Route component={Page404} />
      </Switch>
    </div>
  );
};

export default App;
